"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceScope = exports.serviceEndpoint = void 0;
exports.serviceEndpoint = "{{SERVICE_ENDPOINT_PLACEHOLDER}}";
exports.serviceScope = "{{SERVICE_SCOPE_PLACEHOLDER}}";
//# sourceMappingURL=serviceConstant.js.map